import { gql } from "@apollo/client";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const UPDATE_SERVER = gql`
mutation UpdateServer($domain: String!, $version: String!) {
	server {
		updateServer(domain: $domain, version: $version) {
			code
			success
			message
		}
	}
}
`

export interface UpdateServerResponse {
	server: {
		updateServer: Def_MutationResponse 
	}
}

export interface UpdateServerArgs {
	domain: string;
	version: string;
}

